









import { Component, Vue } from 'vue-property-decorator';
import EditIssueForm from './components/editIssueForm.vue';
import { issueListInstance } from '@/model/IssueListClass';
import { CLOSE_TAG_VIEW_EVENT, pubsub } from '@/utils/pubsub';

@Component({
  components: {
    EditIssueForm,
  },
})
export default class CreateIssue extends Vue {
  private issueInfo: IIssue.IRequest.IUpdateIssueInfo = {
    urgency: 0,
    title: '',
    description: '',
  };
  private createIssue(
    issue: IIssue.IRequest.IUpdateIssueInfo,
  ): Promise<string> {
    return new Promise((resolve, reject) => {
      issueListInstance
        .requestCreateItem(issue)
        .then((res) => {
          resolve(res);
          this.goBack();
        })
        .catch((err) => {
          reject(err);
        });
    });
  }
  private goBack() {
    pubsub.publish(CLOSE_TAG_VIEW_EVENT, this.$route.path);
    this.$router.go(-1);
  }
}
